import { type User } from '../models';
import { type RecordId } from 'javascripts/shared-types';
import RecordFilter from './RecordFilter';

type UserAttribute = 'assignedToUser' | 'createdByUser' | 'user';

class UserFilter<
  A extends UserAttribute = 'assignedToUser'
> extends RecordFilter {
  userAttribute: A;

  constructor(
    initialItems: RecordId[],
    initialOptions: [string, RecordId][] = [],
    filterOptions: { userAttribute?: A } = {}
  ) {
    super(initialItems, initialOptions, filterOptions);
    // @ts-ignore
    this.userAttribute = filterOptions.userAttribute || 'assignedToUser';
  }

  matches<T extends { [key in A]?: User }>(record: T): boolean {
    const userAttributeKey: A = this.userAttribute;
    const user = record[userAttributeKey];
    return super.matches(user);
  }
}

export default UserFilter;
